import styled from "styled-components";

export const Step2ScheduleReserveContainerStyled = styled.div`
  padding: 20px 20px 46px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .step_schedule_reserve_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .header_layout {
      margin-bottom: 32px;
    }
    .header_backhome_layout {
      margin-bottom: 32px;
    }
    .dropdown_layout {
      margin-bottom: 22px;
    }
    .button_layout {
      display: flex;
      justify-content: center;
      column-gap: 37px;

      .button1 {
        flex-basis: 167px;
      }
      .button2 {
        flex-basis: 167px;
      }
    }
    .detail_layout {
      margin-bottom: 18px;
    }
  }
  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: ${({ isPreview }) =>
      isPreview ? "0px 20px 30px 20px" : "46px 20px"};
    .breadcrumb_layout {
      display: none;
    }
  }
`;
